export const BrandBlockStyles = {
  width: "180px",
  height: "100%",
  padding: "10px 0",
  '& .BrandBlock__logo': {
    width: "100%",
    height: "auto",
  }
}
